<div class="w-full mx-auto px-4 mb-4">
  <button type="button" (click)="goBackToList()"
    class="inline-flex items-center gap-1.5 mb-4 text-sm text-gray-400 hover:text-white transition-colors">
    <mat-icon class="material-symbols-outlined !text-[18px] !w-[18px] !h-[18px] !leading-[18px]">arrow_back</mat-icon>
    {{ 'PACKAGES_PERSO_MANAGEMENT.BACK_TO_LIST' | translate }}
  </button>
  <div class="mb-2">
    <p class="titre1">
      {{ 'PACKAGES_PERSO_MANAGEMENT.EDIT_PACKAGE' | translate }}
      <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">
        edit
      </mat-icon>
    </p>
  </div>

  @if (isLoading) {
    <div class="flex justify-center items-center h-64">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }

  @if (!isLoading && packageDetail) {
    <div class="max-w-4xl mx-auto">
      @if (hasExistingSession) {
        <div class="mb-4 p-3 rounded-md bg-yellow-50 border border-yellow-300 text-yellow-800 text-sm flex items-center gap-2">
          <mat-icon class="text-yellow-700">warning</mat-icon>
          <span>{{ 'PACKAGES_PERSO_MANAGEMENT.EDIT_DISABLED_SESSION_EXISTS' | translate }}</span>
        </div>
      }
      <div class="space-y-4 text-sm  mb-6">
        <div class="flex gap-3">
          <div class="w-1/2">
            <label class="block text-sm font-medium mb-1">
              {{ 'PACKAGES_PERSO_MANAGEMENT.CREATION_DATE' | translate }}:
            </label>
            <div class="text-white font-medium">
              {{ packageDetail.dateCreation | dateFormat }}
            </div>
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-medium mb-1">
              {{ 'PACKAGES_PERSO_MANAGEMENT.STATUS' | translate }}:
            </label>
            <div class="text-gray-700 font-medium">
              <span [class]="packageDetail.actif ? 'text-green-600' : 'text-red-600'">
                {{ packageDetail.actif ? ('PACKAGES_PERSO_MANAGEMENT.ACTIVE' | translate) :
                ('PACKAGES_PERSO_MANAGEMENT.INACTIVE' | translate) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="space-y-6">
        @for (language of getSelectedLanguagesArray(); track language) {
          <div>
            <div class="mb-3">
              <h4 class="text-base font-semibold text-gray-800 border-b border-gray-200 pb-1">
                @if (language === 'FR') {
                  <span>{{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_FR' | translate }}</span>
                }
                @if (language === 'EN') {
                  <span>{{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_EN' | translate }}</span>
                }
                @if (language === 'ES') {
                  <span>{{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_ES' | translate }}</span>
                }
              </h4>
            </div>
            <div class="flex gap-3 mb-2">
              <div class="w-1/2">
                <label [for]="'nom' + language" class="block text-sm font-medium mb-1 required">
                  {{ 'PACKAGES_PERSO_MANAGEMENT.NAME' | translate }}:
                </label>
                <input [id]="'nom' + language"
                  [value]="language === 'FR' ? packageInfo.nomFR! : language === 'EN' ? packageInfo.nomEN! : packageInfo.nomES!"
                  (input)="updateNameField(language, $any($event.target).value)" [name]="'nom' + language" [required]="true"
                  [disabled]="hasExistingSession"
                  [class]="'w-full rounded-md shadow-sm focus:border-red-300 focus:ring focus:ring-red-200 ' + (!isNameFieldValid(language) ? 'border-red-500 bg-red-50' : 'border-gray-300')">
                  @if (!isNameFieldValid(language)) {
                    <div class="text-red-500 text-xs mt-1">
                      {{ 'PACKAGES_PERSO_MANAGEMENT.VALIDATION_NAME_REQUIRED' | translate }}
                    </div>
                  }
                </div>
                <div class="w-1/2">
                  <label [for]="'description' + language" class="block text-sm font-medium mb-1">
                    {{ 'PACKAGES_PERSO_MANAGEMENT.DESCRIPTION' | translate }}:
                  </label>
                  <textarea [id]="'description' + language"
                    [value]="language === 'FR' ? packageInfo.descriptionFR! : language === 'EN' ? packageInfo.descriptionEN! : packageInfo.descriptionES!"
                    (input)="updateDescriptionField(language, $any($event.target).value)" [name]="'description' + language"
                    [disabled]="hasExistingSession"
                    class="w-full rounded-md border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200"
                    rows="4">
                  </textarea>
                </div>
              </div>
            </div>
          }
        </div>
        @if (packageDetail.hasVideos) {
          <div class="mt-6 flex items-center gap-2">
            <input type="checkbox" id="edit-can-seek-forward" [(ngModel)]="packageInfo.canSeekForward"
              (ngModelChange)="updateFormValidState()" [disabled]="hasExistingSession" class="p-2 rounded-md" />
              <label for="edit-can-seek-forward" class="text-sm">
                {{ 'PACKAGES_PERSO_MANAGEMENT.ALLOW_SEEK_FORWARD' | translate }}
              </label>
            </div>
          }
          @if (!packageDetail.hasVideos) {
            <div class="mt-6 flex items-center gap-2">
              <input type="checkbox" id="edit-reading-confirmation-required" [(ngModel)]="packageInfo.readingConfirmationRequired"
                (ngModelChange)="updateFormValidState()" [disabled]="hasExistingSession" class="p-2 rounded-md" />
                <label for="edit-reading-confirmation-required" class="text-sm">
                  {{ 'PACKAGES_PERSO_MANAGEMENT.CONFIRMATION_LECTURE_REQUISE_LABEL' | translate }}
                </label>
              </div>
            }
            @if (hasQuestions()) {
              <div class="space-y-4 mt-8">
                <h3 class="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2 normal-case">
                  {{ 'PACKAGES_PERSO_MANAGEMENT.QUESTIONS' | translate }}
                </h3>
                <mat-accordion>
                  @for (question of packageInfo.questions; track question; let questionIndex = $index) {
                    <mat-expansion-panel
                      class="bordered-expansion-panel">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{ 'PACKAGES_PERSO_MANAGEMENT.QUESTION' | translate }} {{questionIndex + 1}}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="space-y-4">
                        @for (language of getSelectedLanguagesArray(); track language) {
                          <div>
                            <label class="block text-sm mb-1">
                              {{ 'PACKAGES_PERSO_MANAGEMENT.QUESTION_TEXT' | translate }}
                              @if (language === 'FR') {
                                <span> ({{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_FR' | translate }})</span>
                              }
                              @if (language === 'EN') {
                                <span> ({{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_EN' | translate }})</span>
                              }
                              @if (language === 'ES') {
                                <span> ({{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_ES' | translate }})</span>
                              }
                            </label>
                            <textarea
                              [value]="language === 'FR' ? question.textFR : language === 'EN' ? question.textEN : question.textES"
                              (input)="updateQuestionText(questionIndex, language, $any($event.target).value)"
                              [disabled]="hasExistingSession"
                              [class]="'w-full rounded-md shadow-sm focus:border-red-300 focus:ring focus:ring-red-200 ' + (!isQuestionTextValid(question, language) ? 'border-red-500 bg-red-50' : 'border-gray-300')"
                              rows="3" required>
                            </textarea>
                            @if (!isQuestionTextValid(question, language)) {
                              <div class="text-red-500 text-xs mt-1">
                                {{ 'PACKAGES_PERSO_MANAGEMENT.VALIDATION_QUESTION_REQUIRED' | translate }}
                              </div>
                            }
                          </div>
                        }
                        <div class="mt-6">
                          <h5 class="text-sm reponses-section-title mb-3">
                            {{ 'PACKAGES_PERSO_MANAGEMENT.ANSWERS' | translate }}
                          </h5>
                          @for (answer of question.answers; track answer; let answerIndex = $index) {
                            <div
                              class="mb-4 p-3 bg-gray-50 rounded-md">
                              <div class="flex items-center mb-2">
                                <span class="text-sm reponse-label">
                                  {{ 'PACKAGES_PERSO_MANAGEMENT.ANSWER' | translate }} {{answerIndex + 1}}
                                </span>
                                @if (answer.isCorrect) {
                                  <span
                                    class="ml-2 px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">
                                    {{ 'PACKAGES_PERSO_MANAGEMENT.CORRECT' | translate }}
                                  </span>
                                }
                              </div>
                              <div class="space-y-2">
                                @for (language of getSelectedLanguagesArray(); track language) {
                                  <div>
                                    <label class="block text-sm mb-1">
                                      @if (language === 'FR') {
                                        <span>{{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_FR' | translate }}</span>
                                      }
                                      @if (language === 'EN') {
                                        <span>{{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_EN' | translate }}</span>
                                      }
                                      @if (language === 'ES') {
                                        <span>{{ 'PACKAGES_PERSO_MANAGEMENT.LANGUAGE_ES' | translate }}</span>
                                      }
                                    </label>
                                    <input type="text"
                                      [value]="language === 'FR' ? answer.textFR : language === 'EN' ? answer.textEN : answer.textES"
                                      (input)="updateAnswerText(questionIndex, answerIndex, language, $any($event.target).value)"
                                      [disabled]="hasExistingSession"
                                      [class]="'w-full rounded-md shadow-sm focus:border-red-300 focus:ring focus:ring-red-200 text-sm ' + (!isAnswerTextValid(answer, language) ? 'border-red-500 bg-red-50' : 'border-gray-300')"
                                      required />
                                      @if (!isAnswerTextValid(answer, language)) {
                                        <div class="text-red-500 text-xs mt-1">
                                          {{ 'PACKAGES_PERSO_MANAGEMENT.VALIDATION_ANSWER_REQUIRED' | translate }}
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </div>
              }
              <div class="flex justify-between items-center mt-8 pt-6">
                <button type="button" (click)="cancelEdit()" class="btn-secondary-novo" [disabled]="isSaving">
                  {{ 'PACKAGES_PERSO_MANAGEMENT.CANCEL' | translate }}
                </button>
                <div class="space-x-3">
                  <button type="button" (click)="saveChanges()" class="btn-primary-novo" [disabled]="isButtonDisabled">
                    @if (isSaving) {
                      <span class="inline-flex items-center">
                        <mat-spinner [diameter]="20" class="mr-2"></mat-spinner>
                        {{ 'PACKAGES_PERSO_MANAGEMENT.SAVING' | translate }}
                      </span>
                    }
                    @if (!isSaving) {
                      <span>
                        {{ 'COMMUN.ENREGISTRER' | translate }}
                      </span>
                    }
                  </button>
                </div>
              </div>
            </div>
          }

          @if (!isLoading && !packageDetail) {
            <div class="text-center py-12">
              <mat-icon class="text-gray-400 text-6xl mb-4">error_outline</mat-icon>
              <h3 class="text-lg font-semibold text-gray-900 mb-2 normal-case">
                {{ 'PACKAGES_PERSO_MANAGEMENT.PACKAGE_NOT_FOUND' | translate }}
              </h3>
              <button (click)="goBack()" class="btn-primary-novo mt-4">
                {{ 'COMMUN.RETOUR' | translate }}
              </button>
            </div>
          }
        </div>